/**
 * User Feedback API client — map-improvement reports submitted from the phone.
 */
import { getIdToken } from '../contexts/AuthContext';
import { buildApiUrl, getAuthHeaders } from '../config/api';

async function authedFetch(endpoint, options = {}) {
  const idToken = await getIdToken();
  if (!idToken) throw new Error('Not authenticated. Please log in.');

  const response = await fetch(buildApiUrl(endpoint), {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...getAuthHeaders(idToken),
      ...(options.headers || {}),
    },
  });

  const body = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(body.message || body.error || `Request failed: ${response.statusText}`);
    error.status = response.status;
    error.payload = body;
    throw error;
  }
  return body;
}

const qs = (params) => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value != null && value !== '') search.set(key, value);
  });
  const str = search.toString();
  return str ? `?${str}` : '';
};

/**
 * Reports in a date range, joined to the map data they are about.
 * @param {{startDate?, endDate?, skiAreaId?, type?, status?}} filters
 */
export const fetchFeedback = (filters = {}) =>
  authedFetch(`/map-management/feedback${qs(filters)}`);

/**
 * The geometry behind one report, for the detail map.
 * Rejects with `error.status === 404` when the feature is gone from the map DB.
 */
export const fetchReportGeometry = ({ type, skiAreaId, featureId, latitude, longitude }) =>
  authedFetch(`/map-management/feedback/geometry${qs({
    type, skiAreaId, featureId, lat: latitude, lng: longitude,
  })}`);

/** Set the triage status and/or notes on one report. */
export const saveTriage = (reportId, patch) =>
  authedFetch(`/map-management/feedback/${encodeURIComponent(reportId)}/triage`, {
    method: 'POST',
    body: JSON.stringify(patch),
  });
